import { PartyPopper, Star, Flag, Music, Tent, Sun, Gift, Heart, MapPin, CalendarDays, Trophy, Utensils } from "lucide-react";

export const EVENT_ICONS = {
  star: Star,
  party: PartyPopper,
  flag: Flag,
  music: Music,
  tent: Tent,
  sun: Sun,
  gift: Gift,
  heart: Heart,
  "map-pin": MapPin,
  calendar: CalendarDays,
  trophy: Trophy,
  food: Utensils,
};

export const EVENT_ICON_NAMES = Object.keys(EVENT_ICONS);

const monthDay = (iso) => {
  const [, m, d] = iso.split("-").map(Number);
  return m * 100 + d;
};

// date: JS Date, events: [{ name, start, end, icon, repeat_yearly }]
// Returns { label, Icon } if the date falls within a custom event, else null.
export function getCustomEvent(date, events) {
  if (!events?.length) return null;
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const dval = m * 100 + d;
  const isoDate = `${date.getFullYear()}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  for (const ev of events) {
    if (!ev.start || !ev.end) continue;
    const Icon = EVENT_ICONS[ev.icon] || Star;
    if (ev.repeat_yearly) {
      const s = monthDay(ev.start);
      const e = monthDay(ev.end);
      const hit = s <= e ? dval >= s && dval <= e : dval >= s || dval <= e;
      if (hit) return { label: ev.name, Icon };
    } else if (isoDate >= ev.start && isoDate <= ev.end) {
      return { label: ev.name, Icon };
    }
  }
  return null;
}
